import {useEffect, useState} from "react";
import {ThinCloseIcon} from "../icons/material-icons";

export const ChooseModal = (props: {
    active: boolean,
    closeHandler: any,
    onDone: any,
    options: {key:string,value:string}[],
    currentKey: string,
    title: string,
    question: string,
    submitText:string,
}) => {
    const [status, setStatus] = useState('');
    useEffect(() => {
        const isActive = props.active;
        const _current = props.currentKey;
        if (isActive) {
            document.body.classList.add("body-no-scroll");
            setStatus(_current);
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')} style={{top:20}}>
                <div className="web-modal-header">
                    <div><b>{props.title}</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="add-student">
                        <label>{props.question}</label>
                        {
                            props.options.map((s, i) =>
                                <button
                                    key={"K38Sj89DDj_sn38SS" + i}
                                    className={"techaran-radio-box" + (status === s.key ? ' active' : '')}
                                    onClick={() => setStatus(s.key)}>
                                    <div><i/></div>
                                    <span>{s.value}</span>
                                </button>
                            )
                        }
                        <div className="d-flex justify-content-end align-items-center"
                             style={{gap: 20, marginTop: 20}}>
                            <button className="cancel-button" onClick={props.closeHandler}>
                                <b>انصراف</b>
                            </button>
                            <button className="btn-pay" onClick={() => {
                                const _current = status;
                                props.onDone(_current);
                                props.closeHandler();
                            }}>
                                <b>{props.submitText}</b>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};